import Actions from './actions';
export default class Dispatcher {
    constructor(dispatch) {
        this.dispatch = dispatch;
    }

    fetchStart = () => this.dispatch({ type: Actions.FETCH_START, payload: {} });

}